(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["template-product"]) return;
  try {
    
  addEventListener('load', (event) => {});
  onload = (event) => {
    // PDP_EVENT GA4
    // gtag('event', 'view_item', {
    //   currency: 'CLP',
    //   value: '2',
    //   items: [
    //     {
    //       item_id: 'SKU_12345',
    //       item_name: 'Stan and Friends Tee',
    //       affiliation: 'Google Merchandise Store',
    //       coupon: 'SUMMER_FUN',
    //       discount: 2.22,
    //       index: 0,
    //       item_brand: 'Google',
    //       item_category: 'Apparel',
    //       item_category2: 'Adult',
    //       item_category3: 'Shirts',
    //       item_category4: 'Crew',
    //       item_category5: 'Short sleeve',
    //       item_list_id: 'related_products',
    //       item_list_name: 'Related Products',
    //       item_variant: 'green',
    //       location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
    //       price: 9.99,
    //       quantity: 1,
    //     },
    //   ],
    // });
  };

  } catch(e) { console.error(e); }
})();

})();
